import React, { useState } from "react";
import { toast } from "sonner";
import { Scissors, Loader2 } from "lucide-react";
import api from "@/lib/api";

/** AI Tools -> "One-Page Auto-Fit": shortens summary/bullets in place so the resume is more
 * likely to fit one printed page. Applied straight to the draft (not a new Version). */
export default function TrimToFitCard({ draft, setDraft }) {
  const [loading, setLoading] = useState(false);

  const trim = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/resume-builder/trim-to-fit", { draft });
      setDraft({ ...draft, summary: data.summary, experience: data.experience, projects: data.projects, internships: data.internships });
      toast.success("Resume tightened up to better fit one page");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not trim your resume right now");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="glass-panel rounded-2xl p-4" data-testid="ai-tool-card-trim">
      <div className="flex items-center gap-2 mb-1.5">
        <Scissors className="w-4 h-4 text-orange-400" />
        <p className="text-sm font-semibold text-white">One-Page Auto-Fit</p>
      </div>
      <p className="text-xs text-slate-400 mb-3">Tighten your summary and bullet points so your resume is more likely to fit on a single page.</p>
      <button
        onClick={trim} disabled={loading} data-testid="ai-tool-trim-button"
        className="flex items-center justify-center gap-1.5 w-full bg-orange-500 hover:bg-orange-400 disabled:opacity-60 text-white text-xs font-semibold px-4 py-2 rounded-lg transition-colors"
      >
        {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Scissors className="w-3.5 h-3.5" />} Trim to Fit One Page
      </button>
    </div>
  );
}
